export default {
  title: 'Alătură-te {{name}}!',
  default_program_name: 'Club Recompense',
  savings_highlight: {
    title: 'Fii recompensat. La fiecare comandă.',
    subtitle: 'Înregistrează-te în câteva secunde și câștigă puncte.',
  },
  how_it_works: {
    label: 'Cum funcționează',
    step_1: {
      title: 'Înregistrare în 30s',
      desc: 'Doar numărul de telefon',
    },
    step_2: {
      title: 'Comandă și câștigă',
      desc: '{{percentage}}% înapoi la fiecare comandă',
    },
    step_3: {
      title: 'Valorifică și economisește',
      desc: 'Până la {{amount}} reducere per comandă',
    },
  },
  profile: {
    verified_title: 'Telefon verificat!',
    verified_subtitle: 'Completează-ți profilul pentru a începe să câștigi.',
  },
  form: {
    phone_number: {
      label: 'Număr de telefon',
      description: 'Îți vom trimite un cod de verificare pentru a confirma că ești tu.',
      placeholder: 'Număr de telefon',
    },
    birthday: {
      label: 'Zi de naștere — ziua și luna sunt suficiente pentru un cadou 🥳',
      placeholder: 'Zi de naștere (opțional)',
      parts: {
        month: 'Lună',
        day: 'Zi',
      },
    },
  },
  terms:
    'Prin înregistrare, ești de acord cu <TermsLink>termenii și condițiile</TermsLink> noastre și consimți la <PrivacyPolicyLink>politica de confidențialitate</PrivacyPolicyLink>.',
  buttons: {
    continue: 'Continuă',
    verify: 'Verifică',
    complete: 'Finalizează înregistrarea',
  },
  toasts: {
    login_success: 'Te-ai conectat cu succes',
    invalid_code: 'Cod invalid. Încearcă din nou.',
    failed_to_update_profile: 'Actualizarea profilului a eșuat. Încearcă din nou.',
  },
};
